import { render, staticRenderFns } from "./BacModal.vue?vue&type=template&id=53884248&scoped=true&"
import script from "./BacModal.vue?vue&type=script&lang=ts&"
export * from "./BacModal.vue?vue&type=script&lang=ts&"
import style0 from "./BacModal.vue?vue&type=style&index=0&id=53884248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53884248",
  null
  
)

export default component.exports